'use client';

import { Container, SectionLabel } from '../ReferenceChrome';

const PILLARS = [
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'See what is happening',
    desc: 'Search Console data explained in plain English: slipping pages, low-click titles, and close-to-ranking keywords.',
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    title: 'Know what matters now',
    desc: 'A simple, prioritized checklist of tasks. Every time you log in, you know exactly what action to take next.',
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    title: 'Decide and execute',
    desc: 'Pre-generated fixes ready for you. Review the recommended titles and refresh plans, apply them, and mark them done.',
  },
];

export function IntroRef() {
  return (
    <section className="py-16 sm:py-20">
      <Container className="text-center">
        <SectionLabel>The job</SectionLabel>
        <h2 className="mx-auto mt-5 max-w-2xl text-2xl font-normal leading-snug tracking-tight text-gray-900 sm:text-[2rem]">
          Stop guessing.{' '}
          <span className="text-gray-400">Stop drowning in dashboards.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-gray-500">
          Other SEO tools hand you data and trust you to be the analyst. RankGrip does the
          interpreting. You decide. The next step stays small enough to start.
        </p>
      </Container>

      {/*
        Bordered pillar row — edges align with the two vertical rail lines.
        ─────────── top border ───────────
        │ pillar1 │ pillar2 │ pillar3 │
        ─────────── bottom border ────────
      */}
      <div
        className="rail-inset-x mt-14 border-t border-b border-gray-200"
      >
        <div className="grid grid-cols-1 divide-y divide-gray-200 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
          {PILLARS.map((p) => (
            <div key={p.title} className="flex flex-col gap-3 px-8 py-8 sm:px-10">
              <span className="flex size-9 items-center justify-center rounded-sm border border-gray-200 bg-gray-50 text-[#129990]">
                {p.icon}
              </span>
              <p className="text-sm font-semibold text-gray-900">{p.title}</p>
              <p className="text-sm font-light leading-relaxed text-gray-500">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
